export default "__VITE_ASSET__DjpcSBr4__"